/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import { Component } from '@angular/core';

@Component({
  selector: 'clr-vertical-nav-group-children',
  template: `<ng-content></ng-content>`,
})
export class ClrVerticalNavGroupChildren {}
